import React from 'react';
import { CtaButton } from './CtaButton';
import { images } from '../data/offer';
export function CreatorSection() {
  return <section className="w-full bg-navy-950 px-5 py-16 text-white sm:py-20" data-id="element-62" data-mp="1wzyp8g6a8rxm">
      <div className="mx-auto max-w-5xl" data-id="element-63" data-mp="1j2a02w56mymr">
        <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12" data-id="element-64" data-mp="1j18mol0p201v">
          <div className="-mx-5 sm:mx-0" data-id="element-65" data-mp="1o2oceqdtguql">
            <img src={images.creator} alt="Jason Mitchell at his workbench with TCM modules and diagnostic tools" className="w-full sm:rounded-3xl lg:sticky lg:top-8" data-id="element-66" data-mp="19b5m9zr8tjti" />
          </div>
          <div data-id="element-67" data-mp="10ckacnga131p">
            <p className="font-display text-lg font-bold uppercase tracking-wider text-electric-400" data-id="element-68" data-mp="108wehhnd04jt">About the creator</p>
            <h2 className="mt-1 font-display text-[48px] font-black uppercase leading-none" data-id="element-69" data-mp="qctae68y5vu8">Jason Mitchell</h2>
            <p className="mt-2 text-[15px] font-semibold text-gold-400" data-id="element-70" data-mp="vbmoo0w25qvg">
              Automotive Electronics Technician &amp; Creator of TCM Diagnostic Blueprint™
            </p>
            <div className="mt-6 space-y-4 text-[16px] leading-relaxed text-slate-300" data-id="element-71" data-mp="pnbk3z5pk6tl">
              <p data-id="element-72" data-mp="koibak1d93zr">For years, I've seen the same challenge come up again and again in automotive electronics.</p>
              <p data-id="element-73" data-mp="ukll8c2gm6x9">
                A technician can have experience, diagnostic equipment, programmers, and a computer full of saved
                information. But when an unfamiliar module arrives at the workbench, one question can still be difficult
                to answer:
              </p>
              <p className="font-display text-[30px] font-extrabold uppercase text-white" data-id="element-74" data-mp="fnazm9w3rknt">“Where should I start?”</p>
              <p data-id="element-75" data-mp="awujgi0wdkxr">
                You watch one tutorial, read another forum post, open a technical manual, and search through old notes.
                Before long, you've spent a significant amount of time looking for information without a clear process
                for organizing it.
              </p>
              <p data-id="element-76" data-mp="1iapvfpwqur55">
                That observation led me to develop TCM Diagnostic Blueprint™ — a practical visual system built around
                decision maps, troubleshooting routes, checklists, and workshop documentation. Something that helps you
                move from a vague problem to a structured investigation.
              </p>
              <p data-id="element-77" data-mp="1wyay5ippiocj">
                I also wanted to make it accessible without requiring a large financial commitment, because a
                well-organized workflow can be valuable even when you already have years of technical experience.
              </p>
              <p data-id="element-78" data-mp="1998i2faq13k5">
                My goal isn't to replace hands-on training, manufacturer documentation, or specialist knowledge. It's to
                give you a practical framework that helps you organize the work you already know how to do—and recognize
                when you need more information.
              </p>
              <p className="border-l-4 border-electric-500 pl-4 text-lg font-semibold text-white" data-id="element-79" data-mp="2pm6v8oj6ui9u">
                You don't need to memorize every possible TCM problem. You need a structured process for deciding what to
                investigate next.
              </p>
              <p className="italic text-slate-400" data-id="element-80" data-mp="49tmu3jcugx3">— Jason Mitchell</p>
            </div>
          </div>
        </div>
        <CtaButton label="I want Jason's TCM system" tone="dark" className="mt-12" data-id="element-81" data-mp="3vg3d4amx0rx3" />
      </div>
    </section>;
}